import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../root-saga/root-state';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.portal || initialState;

export const selectCurrentUser = createSelector(
  [selectSlice],
  (state) => state.user,
);

export const selectIsAuthenticated = createSelector(
  [selectSlice],
  (state) => state.isAuthenticated,
);

export const selectBootstrapping = createSelector(
  [selectSlice],
  (state) => state.bootstrapping,
);
